import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=585f3cd2"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('585f3cd2')) {
      api.createRecord('585f3cd2', component.options)
    } else {
      api.reload('585f3cd2', component.options)
    }
    module.hot.accept("./Questions.vue?vue&type=template&id=585f3cd2", function () {
      api.rerender('585f3cd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/faq/Questions.vue"
export default component.exports